const r=r=>{if(void 0!==r)return!r||Array.isArray(r)&&!r.length?"falso":"verdadeiro"};export{r as default};
